//import { initOnLoad } from "apexcharts";

import { color } from "d3";

// playground requires you to assign document definition to a variable called dd
export const convertToPDFReport = ({ type, invoiceData, firm, fromDate, toDate }) => {
    var dd = {
        pageOrientation: 'landscape',
        content: [
            {
                table: {
                    widths: ['20%', '30%', '25%', '25%'],
                    body: [
                        [

                            { text: '', style: "reportHeader1" },
                            { text: 'FIRM NOT SELECTED\n', style: "reportHeader" },
                            { text: 'From: NOT SELECTED\n', style: "reportHeader" },
                            { text: 'To: NOT SELECTED\n', style: "reportHeader" },
                        ],

                    ]
                }

            },
            { text: '\n', style: '' },
            {
                table: {

                    body: [
                        [

                            { text: 'Invoice Date', style: "gstHeader" },
                            { text: 'Invoice No.', style: "gstHeader" },
                            { text: 'Particulars', style: "gstHeaderBuyer1" },
                            { text: 'Total', style: "gstHeaderTotal1" },
                            { text: 'Basic', style: "gstHeaderBasic1" },
                            { text: 'GST', style: "gstHeaderBasic1" },
                            { text: 'Discount', style: "gstHeaderBasic1" },
                            // { text: 'Paid ', style: "gstHeader" },
                            // { text: 'Remaining', style: "gstHeader" },
                            // { text: 'Duration', style: "gstHeader" },
                            // { text: 'Payment Type', style: "gstHeader" },
                            // { text: 'Status', style: "gstHeader" },
                            // { text: 'Transaction Type', style: "gstHeader" },
                            { text: 'GST type', style: "gstHeader" },
                            { text: 'IGST', style: "gstHeader" },
                            { text: 'SGST', style: "gstHeader" },
                            { text: 'CGST', style: "gstHeader" },
                            { text: 'GST(3%)', style: "gstHeader" },
                            { text: 'GST(5%)', style: "gstHeader" },
                            { text: 'GST(12%)', style: "gstHeader" },
                            { text: 'GST(18%)', style: "gstHeader" },
                            { text: 'GST(28%)', style: "gstHeader" },
                            { text: 'Vocher Type', style: "gstHeader" },
                            // { text: 'Firm', style: "gstHeader" },
                        ],

                    ]
                }

            },

        ],
        styles: {
            gstHeader: {
                fontSize: 6,
                bold: true,
                alignment: 'center'
            },
            gstHeaderBuyer1: {
                fontSize: 6,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeaderTotal1: {
                fontSize: 6,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeaderBasic1: {
                fontSize: 6,
                bold: true,
                alignment: 'center',
            },
            gstHeaderBuyer: {
                fontSize: 8,
                bold: true,
                alignment: 'left',
                color: '#160091'
            },
            gstHeaderTotal: {
                fontSize: 8,
                bold: true,
                alignment: 'right',
                color: '#160091'
            },
            gstHeaderBasic: {
                fontSize: 7,
                bold: true,
                alignment: 'right',
            },
            gstData: {
                fontSize: 7,
                bold: true,
                alignment: 'center'
            },
            gstHeaderInvoice: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            reportHeader: {
                fontSize: 12,
                bold: true,
                alignment: 'center'
            },
            reportHeader1: {
                fontSize: 14,
                bold: true,
                alignment: 'left',
                color:"#160091"
            }
        }

    }

    if (type) {
        dd.content[0].table.body[0][0].text = type
    }
    if (firm) {
        dd.content[0].table.body[0][1].text = '' + firm + '\n';
    }
    if (fromDate) {
        dd.content[0].table.body[0][2].text = 'From ' + fromDate + '\n';
    }
    if (toDate) {
        dd.content[0].table.body[0][3].text = 'To ' + toDate + '\n';
    }

    invoiceData.map((invoice) => {
        if (!invoice.totalColum_debit && !invoice.totalColum_seller) {
            dd.content[2].table.body.push(
                [
                    { text: invoice.firmName == 'Total' ? 'Total' : new Date(invoice.date).toLocaleDateString('en-GB'), style: "gstData" },
                    { text: invoice.invoiceId, style: "gstHeaderInvoice" },
                    { text: invoice.buyerName, style: "gstHeaderBuyer" },
                    { text: Number.parseFloat(invoice.totalAmount).toFixed(1), style: "gstHeaderTotal" },
                    { text: Number.parseFloat(invoice.BASIC_AMOUNT).toFixed(1), style: "gstHeaderBasic" },
                    { text: Number.parseFloat(invoice.GST_TOTAL).toFixed(1), style: "gstHeaderBasic" },
                    { text: Number.parseFloat(invoice.discountAmount).toFixed(1), style: "gstHeaderBasic" },
                    // { text: Number.parseFloat(invoice.paidAmount).toFixed(1), style: "gstData" },
                    // { text: Number.parseFloat(invoice.remainingAmount).toFixed(1), style: "gstData" },
                    // { text: invoice.duration, style: "gstData" },
                    // { text: invoice.paymentType, style: "gstData" },
                    // { text: invoice.status, style: "gstData" },
                    // { text: invoice.transactionType, style: "gstData" },
                    { text: invoice.gstType, style: "gstData" },
                    { text: Number.parseFloat(invoice.IGST).toFixed(1), style: "gstHeaderBasic" },
                    { text: Number.parseFloat(invoice.SGST).toFixed(1), style: "gstHeaderBasic" },
                    { text: Number.parseFloat(invoice.CGST).toFixed(1), style: "gstHeaderBasic" },
                    { text: Number.parseFloat(invoice.GST_3).toFixed(1), style: "gstHeaderBasic" },
                    { text: Number.parseFloat(invoice.GST_5).toFixed(1), style: "gstHeaderBasic" },
                    { text: Number.parseFloat(invoice.GST_12).toFixed(1), style: "gstHeaderBasic" },
                    { text: Number.parseFloat(invoice.GST_18).toFixed(1), style: "gstHeaderBasic" },
                    { text: Number.parseFloat(invoice.GST_28).toFixed(1), style: "gstHeaderBasic" },
                    { text: invoice.voucherType, style: "gstData" },
                    // { text: invoice.firmName, style: "gstData" },
                ]
            )
        }
    })
    return dd;
}


// WEBPACK FOOTER //
// ./src/utils/pdf-reports/dashboard-reports.js